module.exports = __webpack_public_path__ + "img/news_head_1.6d380167.jpg";